import { render, staticRenderFns } from "./EditCategoryDialog.vue?vue&type=template&id=209ef674&scoped=true"
import script from "./EditCategoryDialog.vue?vue&type=script&lang=ts"
export * from "./EditCategoryDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditCategoryDialog.vue?vue&type=style&index=0&id=209ef674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209ef674",
  null
  
)

export default component.exports